const ADMIN_ROLE_ID = 1;

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
};

export const getCurrentUserRoleId = () => {
  const user = getStoredUser();
  const roleId = user?.roleId ?? user?.RoleId ?? user?.role?.id ?? null;
  return roleId != null && roleId !== "" ? Number(roleId) : null;
};

export const getCurrentUserRoleNames = () => {
  const user = getStoredUser();
  const roles = user?.roleNames ?? user?.RoleNames ?? [];
  return Array.isArray(roles) ? roles.map((r) => String(r)) : [];
};

export const hasRole = (roleName) => {
  if (!roleName) return false;
  const normalized = String(roleName).toLowerCase();
  return getCurrentUserRoleNames().some((r) => String(r).toLowerCase() === normalized);
};

export const isAdminUser = () =>
  getCurrentUserRoleId() === ADMIN_ROLE_ID || hasRole("Admin");

/** کاربر مدیریت (UserKind.Management) یا Admin سامانه */
export const isManagementUser = () => {
  if (isAdminUser() || hasRole("Management") || hasRole("مدیریت")) return true;
  const user = getStoredUser();
  if (!user) return false;
  const kind = user.userKind ?? user.UserKind ?? user.user_kind ?? null;
  if (kind == null) return false;
  const kindStr = String(kind).toLowerCase();
  return kindStr === "management" || kindStr === "2";
};

export const isPartnerUser = () => hasRole("Partner");

export const canAccessMarketGrowthAdmin = () => isAdminUser();

export const canAccessPartnerPortal = () => isPartnerUser();

/**
 * Phase 7.4.0 — Contractor Portal access.
 * Accepts Contractor role name and/or userKind markers used by Solarent auth payloads.
 */
export const isContractorUser = () => {
  if (hasRole("Contractor") || hasRole("ContractorMember")) return true;
  const user = getStoredUser();
  if (!user) return false;
  const kind = user.userKind ?? user.UserKind ?? user.user_kind ?? null;
  if (kind == null) return false;
  const kindStr = String(kind).toLowerCase();
  return kindStr === "contractor" || kindStr === "3" || kindStr === "5";
};

export const isContractorPrimaryUser = () => hasRole("Contractor");

export const isContractorMemberUser = () =>
  hasRole("ContractorMember") && !hasRole("Contractor");

/** Primary or team member — dashboard / assisted registration / portal APIs. */
export const canAccessContractorPortal = () => isContractorUser();

export const canAccessContractorAssistedRegistration = () => isContractorUser();

/** Team management — primary contractor account only. */
export const canManageContractorTeam = () => isContractorPrimaryUser();

/** Distribution company portal — JWT claims + userKind. */
export const isDistributionCompanyUser = () => {
  if (
    hasRole("DistributionCompanyAdmin") ||
    hasRole("DistributionCompanyMember")
  ) {
    return true;
  }
  const user = getStoredUser();
  if (!user) return false;
  const kind = user.userKind ?? user.UserKind ?? user.user_kind ?? null;
  if (kind == null) return false;
  const kindStr = String(kind).toLowerCase();
  return (
    kindStr === "distributioncompany" ||
    kindStr === "10" ||
    kindStr === "شرکت‌های توزیع" ||
    kindStr === "شرکت های توزیع"
  );
};

export const isDistributionCompanyAdminUser = () =>
  hasRole("DistributionCompanyAdmin");

export const canManageDistributionTeam = () =>
  isDistributionCompanyAdminUser() || isAdminUser();

export const canAccessDistributionPortal = () =>
  isDistributionCompanyUser() || isAdminUser();
